import React from 'react';
import { PropagateLoader } from 'react-spinners';
export default function LoadingComponent({
  style,
  color = 'var(--color-base400)'
}) {
  return /*#__PURE__*/React.createElement(PropagateLoader, {
    color: color,
    style: {
      ...style,
      height: 16
    }
  });
}